import { render, staticRenderFns } from "./EpayTradeDetail.vue?vue&type=template&id=ffdd7c50&scoped=true"
import script from "./EpayTradeDetail.vue?vue&type=script&lang=js"
export * from "./EpayTradeDetail.vue?vue&type=script&lang=js"
import style0 from "./EpayTradeDetail.vue?vue&type=style&index=0&id=ffdd7c50&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdd7c50",
  null
  
)

export default component.exports